<template>
    <div id="app">
        <!-- Header -->
        <div class="header" ref="header">
            <template v-if="!!embedded">
                <div class="buttons buttons-embedded">
                    <!-- Emedded header -->
                    <button
                        v-if="!root || backSearch"
                        @click="
                            () => {
                                if (backSearch) {
                                    routeBackSearch();
                                } else {
                                    if ($router.currentRoute.path.endsWith('/'))
                                        $router.push('../');
                                    else $router.push('./');
                                }
                            }
                        "
                        id="back"
                        class="back"
                    >
                        Back
                    </button>
                    <button
                        onclick="window.open(
                                            '/upload',
                                            '_blank'
                                        );"
                        class="upload button-green"
                    >
                        Upload
                    </button>
                </div>
            </template>
            <template v-else>
                <router-link
                    :to="{ name: 'home' }"
                    tag="div"
                    class="logo"
                ></router-link>
                <div class="buttons">
                    <button
                        @click="
                            () => {
                                if (backSearch) {
                                    routeBackSearch();
                                } else {
                                    if ($router.currentRoute.path.endsWith('/'))
                                        $router.push('../');
                                    else $router.push('./');
                                }
                            }
                        "
                        v-if="!root || backSearch"
                        id="back"
                        class="back"
                    >
                        Back
                    </button>
                    <router-link
                        :to="{ name: 'upload' }"
                        tag="button"
                        v-if="!upload"
                        class="upload button-green"
                    >
                        Upload</router-link
                    ><router-link
                        :to="{ name: 'dashboard' }"
                        tag="button"
                        v-if="!dashboard"
                        class="dashboard button-orange"
                    >
                        Dashboard
                    </router-link>
                    <router-link
                        :to="{ name: 'login' }"
                        tag="button"
                        v-if="!this.$store.getters.isAuthenticated"
                    >
                        Login
                    </router-link>
                    <router-link :to="{ name: 'logout' }" tag="button" v-else>
                        Logout
                    </router-link>
                </div>
            </template>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            router: this.$router,
            backSearch: null,
        };
    },
    metaInfo() {
        return {
            title: "schoolbreak.io | maps",
            meta: [
                {
                    name: "description",
                    content:
                        "Share maps for schoolbreak.io: Students versus Teachers! Demolish the school in this multiplayer online game as a student, or decide to protect it as a teacher! Invite your friends now.",
                },
                {
                    property: "og:title",
                    content: "schoolbreak.io | maps",
                },
                {
                    property: "og:site_name",
                    content: "schoolbreak-community-maps",
                },
                { property: "og:type", content: "website" },
                { property: "og:locale", content: "en_US" },
                {
                    property: "og:description",
                    content:
                        "Share maps for schoolbreak.io: Students versus Teachers! Demolish the school in this multiplayer online game as a student, or decide to protect it as a teacher! Invite your friends now.",
                },
                { name: "robots", content: "index,follow" },
            ],
        };
    },
    created() {
        document.documentElement.setAttribute("lang", "en");
    },
    computed: {
        embedded() {
            return "embedded" in this.$router.currentRoute.query;
        },
        root() {
            return this.$router.currentRoute.path === "/";
        },
        editor() {
            return (
                "source" in this.$router.currentRoute.query &&
                this.$router.currentRoute.query.source === "editor"
            );
        },
        upload() {
            return this.$router.currentRoute.path.indexOf("upload") > 0;
        },
        dashboard() {
            return this.$router.currentRoute.path.indexOf("dashboard") > 0;
        },
    },
    updated() {},
    mounted() {
        function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }
        const url = new URL(window.location.href);
        const embedded = url.searchParams.has("embedded");
        const editor =
            url.searchParams.has("source") &&
            url.searchParams.get("source") === "editor";

        if (inIframe() && !embedded) {
            url.searchParams.append("embedded", "true");
            window.location.href = url;
        }

        if (embedded) document.body.setAttribute("data-embedded", null);
        if (editor) document.body.setAttribute("data-editor", null);

        window.addEventListener("load", () => {
            setTimeout(() => {
                const keepParams = document.querySelectorAll("a[keep-params]");
                for (let i = 0; i < keepParams.length; i++) {
                    const a = keepParams[i];
                    a.addEventListener("click", (e) => {
                        e.preventDefault();

                        const params = window.location.search,
                            dest = a.getAttribute("href") + params;

                        window.setTimeout(function() {
                            window.location.href = dest;
                        }, 100);
                    });
                }
            }, 1000);
        });
    },
    methods: {
        routeBackSearch() {
            let query = Object.assign({}, this.$route.query);
            if (Array.isArray(this.backSearch)) {
                for (let i = 0; i < this.backSearch.length; i++) {
                    const search = this.backSearch[i];
                    delete query[search];
                }
            } else {
                delete query[this.backSearch];
            }
            this.$router.replace({ query });
            this.backSearch = null;
        },
    },
};
</script>
<style lang="scss" src="./assets/css/style.scss"></style>
<style scoped lang="scss" src="./assets/css/app.scss"></style>
